/**
 * Created by Karan variya on 27/12/2018.
 */
export class UserDetailModel {
    countryId: string;
    countrygroupId: string;
    createdAt: string;
    currentearning: string;
    deviceid: string;
    downloadamount: string;
    downloadapp: string;
    email: string;
    firstname: string;
    logintype: string;
    pic: string;
    gender: string;
    appsublist: string;
    id: string;
    installapp: string;
    isactive: string;
    isdevice: string;
    joincode: string;
    jsontoken: string;
    lastcheckindate: string;
    lastname: string;
    mobile: string;
    notificationtoken: string;
    password: string;
    ratingamount: string;
    refearning: string;
    referencecode: string;
    reviewamount: string;
    role: string;
    selfearning: string;
    totalearning: string;
    updatedAt: string;
    username: string;
    withdrawcount: string;
    childcount: string;
    parentemail: string;
    parentid: string;
    parentrole: string;

    subscriptions : string;
    ispremiumuser : boolean;
    isprouser : boolean;
    ispurchase : boolean;
    isupgradetopro : boolean;

    registerdate: string;
    lastactivedate : string;
    countryname: string;
    countrygroupname: string;

    appleid: string = "";
    googleid: string = "";
    facebookid: string = "";
    huaweiid: string = "";
    guestid: string = "";
}


// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix HealthCare/HealthCare_UI/src/api/userdetails/UserDetailModel.ts